import * as React from 'react';
import { render } from 'react-dom';
import { MdInfoOutline, MdErrorOutline, MdWarning, MdDoneAll } from 'react-icons/md';
import { Portal } from '../Popover/Portal';
import { notificationSubject$ } from './NotificationService';
import posed, { PoseGroup } from 'react-pose';
import { isBrowser, getColor } from '../../helpers';
import { DARK_THEME } from '../Theme/Theme';
import { ListItem } from '../List';
import { Text } from '../Text';
import { shadow } from '../../helpers/style';
import { style } from './style';
const NOTIFICATION_DIV_ID = 'notification-div-id';
export class NotificationContainer extends React.Component {
    constructor(props) {
        super(props);
        this.getIcon = (index, theme) => {
            const { error, warning, info } = theme;
            const notification = this.state.notification[index];
            switch (notification.type) {
                case 'info':
                    return React.createElement(MdInfoOutline, { style: { color: getColor(info), fontSize: '30px' } });
                case 'error':
                    return React.createElement(MdErrorOutline, { style: { color: getColor(error), fontSize: '30px' } });
                case 'warning':
                    return React.createElement(MdWarning, { style: { color: getColor(warning), fontSize: '30px' } });
                case 'success':
                    return React.createElement(MdDoneAll, { style: { color: getColor('#00c853'), fontSize: '30px' } });
                default:
                    return React.createElement(MdInfoOutline, { style: { color: getColor(info), fontSize: '30px' } });
            }
        };
        this.color = (index, { primary, error, warning }) => ({
            info: primary,
            error,
            warning,
            success: '#00c853',
        }[this.state.notification[index].type]);
        this.state = {
            notification: notificationSubject$.getValue(),
        };
    }
    componentDidMount() {
        notificationSubject$.subscribe((notification) => this.setState({ notification }));
    }
    render() {
        return React.createElement(Container, { notification: this.state.notification, getIcon: this.getIcon, color: this.color });
    }
}
NotificationContainer.defaultProps = {
    type: 'info',
};
const Container = (props) => {
    const css = style;
    const theme = DARK_THEME;
    const { notification, getIcon, color } = props;
    return (React.createElement(Portal, null,
        React.createElement("div", { className: css },
            React.createElement(PoseGroup, null, notification.map((notification, index) => (React.createElement(NotificationTile, { style: notification.style || {}, key: `noti-${index}` },
                React.createElement(ListItem, { avatar: getIcon(index, theme), subtitle: React.createElement(Text, { color: getColor(color(index, theme)) }, notification.message), style: {
                        background: color(index, theme),
                        boxShadow: shadow('2X', theme),
                        borderRadius: '4px',
                        minWidth: '400px',
                        color: getColor(color(index, theme)),
                    } }, notification.title))))))));
};
const NotificationTile = posed.div({
    enter: {
        x: 0,
        opacity: 1,
        transition: {
            y: { ease: 'easeOut', duration: 600 },
            opacity: { ease: 'easeOut', duration: 300 },
        },
    },
    exit: {
        x: '100px',
        opacity: 0,
        transition: {
            x: { ease: 'easeOut', duration: 600 },
            opacity: { ease: 'easeOut', duration: 300 },
        },
    },
});
export const initializeNotification = () => {
    if (isBrowser()) {
        let div = document.getElementById(NOTIFICATION_DIV_ID);
        if (!div) {
            div = document.createElement('div');
            div.id = NOTIFICATION_DIV_ID;
            document.body.append(div);
        }
        render(React.createElement(NotificationContainer, null), div);
    }
};
//# sourceMappingURL=Notification.js.map